module.exports = __webpack_public_path__ + "img/SuperOKBluePink.06b8b237.png";